import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { ModelSetTransformer } from '../common/common.model';
import { mapList } from '../common/rest.operators';

import {
    LobItem,
    LobItemModelSetTransformer,
    validateLob,
} from './lob.pi.model';
import {
    PeerGroupItem,
    PeerGroupItemModelSetTransformer,
    validatePeerGroup,
} from './peergroup.pi.model';
import { RoleItem, RoleModelSetTransformer } from './role.user.model';
import {
    SuperGroupItem,
    SuperGroupItemModelSetTransformer,
    validateSuperGroup,
} from './supergroup.pi.model';

@Injectable()
export class ProfileUserService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private _list<T, U>(
        scopeId: number,
        endpoint: string,
        transformer: new () => ModelSetTransformer<T, U>,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        validator?: <T>(model) => void,
    ): Observable<T[]> {
        const params = new HttpParams().set('scopeID', scopeId.toString());

        return this._http.get(endpoint, { params }).pipe(
            // eslint-disable-next-line new-cap
            mapList(new transformer()),
            catchError((error) => {
                console.error(error);
                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                throw `${endpoint} failed`;
            }),
        );
    }

    listLobs(scopeId: number = 18): Observable<LobItem[]> {
        return this._list(
            scopeId,
            `${this._appConfig.API_ENDPOINTS.PERFORMANCE_DATA}/performancedata/GetAvailableLobs`,
            LobItemModelSetTransformer,
            validateLob,
        );
    }

    listPeerGroups(scopeId: number = 18): Observable<PeerGroupItem[]> {
        return this._list(
            scopeId,
            `${this._appConfig.API_ENDPOINTS.PERFORMANCE_DATA}/performancedata/GetAvailablePeerGroups`,
            PeerGroupItemModelSetTransformer,
            validatePeerGroup,
        );
    }

    listSuperGroups(scopeId: number = 18): Observable<SuperGroupItem[]> {
        return this._list(
            scopeId,
            `${this._appConfig.API_ENDPOINTS.PERFORMANCE_DATA}/performancedata/GetAvailableSuperGroups`,
            SuperGroupItemModelSetTransformer,
            validateSuperGroup,
        );
    }

    listRoles(scopeId: number = 4): Observable<RoleItem[]> {
        return this._list(
            scopeId,
            `${this._appConfig.API_ENDPOINTS.USER_PROFILE}/role/GetAvailableRoles`,
            RoleModelSetTransformer,
        );
    }
}
